import classnames from 'classnames/bind';
import PropTypes from 'prop-types';
import React from 'react';

import { STAGES } from 'app/modules/ui';
import ChatIcon from 'presentation/components/icons/ChatIcon';
import { INITIAL_BUTTON_TYPES } from 'app/modules/configuration/constants';

import styles from 'presentation/components/styles/MinimizedChatButton.css';
let cx = classnames.bind(styles);

export default function MinimizedChatButton(props) {
  const minimizedButtonPropTypes = {
    type: PropTypes.string,
    value: PropTypes.string,
    unreadMessageCount: PropTypes.number,
    onClick: PropTypes.func.isRequired,
    onKeyDown: PropTypes.func.isRequired,
  };

  PropTypes.checkPropTypes(minimizedButtonPropTypes, props, 'prop', 'MinimizedChatButton');
  return renderButton(props);
}

function renderButton(props) {
  const keyPressHandler = event => {
    // Handle enter and space bar key events
    if (event.keyCode == 13 || event.keyCode == 32) {
      event.preventDefault();
      props.onKeyDown(event);
    }
  };

  if (props.type === INITIAL_BUTTON_TYPES.ICON || props.stage !== STAGES.ONBOARDING) {
    return renderIcon(props, keyPressHandler);
  } else if (props.type === INITIAL_BUTTON_TYPES.TEXT || props.stage === STAGES.ONBOARDING) {
    return renderTextButton(props, keyPressHandler);
  }
}

function renderTextButton(props, keyPressHandler) {
  let minimizedChatButtonClasses = cx('minimizedChatButtonSelector', 'initialChatButton');
  return (
    <div
      tabIndex="0"
      role="button"
      className={styles.chatButton_wrapper}
      id="gladlyChatDragHandle"
      onKeyDown={keyPressHandler}
      onClick={props.onClick}
    >
      <button className={minimizedChatButtonClasses} data-aid="gladlyChatChatButton" tabIndex="-1">
        {props.value}
      </button>
    </div>
  );
}

function renderIcon(props, keyPressHandler) {
  let minimizedIconClasses = cx('minimizedChatButtonSelector', 'minimizedChatButton');
  let notificationClasses = cx(styles.minimizedChatButton_notification, 'minimizedChatButton_notification');

  return (
    <div
      tabIndex="0"
      role="button"
      className={styles.chatButton_wrapper}
      id="gladlyChatDragHandle"
      onKeyDown={keyPressHandler}
      onClick={props.onClick}
    >
      <button className={minimizedIconClasses} data-aid="gladlyChatChatButton" tabIndex="-1">
        {props.unreadMessageCount > 0 && <div className={notificationClasses} />}
        <ChatIcon />
      </button>
    </div>
  );
}
